// cleanup_convert_to_typescript_file_PAYMENT_MAPS

import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { CircleIcon, CheckmarkCircleIcon } from '@glu/icons-react';

import { DEFAULT_PROPS } from 'constants.js';

import useStyles from './ImportTypeCheckbox.styles';

const { EMPTY_ARRAY, EMPTY_FUNCTION } = DEFAULT_PROPS;

const ImportTypeCheckboxComponent = ({
  data: { icon = null, label = '', onClick = EMPTY_FUNCTION } = {},
  disableCheckboxes = false,
  disableMultiselect = false,
  highlightBorder = false,
  onSelect = EMPTY_FUNCTION,
  selectedCheckboxes = EMPTY_ARRAY
}) => {
  const { body, checkmark, iconWrapper, label: labelClass, wrapper } = useStyles();

  const onToggleSelect = useCallback(() => {
    let selectedData = [];

    if (disableMultiselect) {
      selectedData = selectedCheckboxes.includes(label) ? [] : [label];

      if (onClick) {
        onClick({ label, selectedData });
      }
      return onSelect(selectedData);
    }

    selectedData = selectedCheckboxes.includes(label)
      ? [...selectedCheckboxes.filter((item) => item !== label)]
      : [...selectedCheckboxes, label];

    if (onClick) {
      onClick({ label, selectedData });
    }

    return onSelect(selectedData);
  }, [selectedCheckboxes, disableMultiselect, onSelect, label, onClick]);

  const isSelected = useMemo(
    () => selectedCheckboxes.includes(label),
    [selectedCheckboxes, label]
  );

  const checkMark = useMemo(() => {
    if (disableCheckboxes) return null;

    return !isSelected ? <CircleIcon /> : <CheckmarkCircleIcon />;
  }, [isSelected, disableCheckboxes]);

  return (
    <button
      aria-pressed={isSelected}
      className={classnames(
        'col-sm-3 no-gutters',
        wrapper,
        highlightBorder && isSelected ? 'highlighted' : ''
      )}
      data-qa={label}
      onClick={onToggleSelect}
    >
      <span className={checkmark}>{checkMark}</span>
      <div className={body}>
        <div className={iconWrapper}>{icon}</div>
        <span className={labelClass}>{label}</span>
      </div>
    </button>
  );
};

ImportTypeCheckboxComponent.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.node]),
    onClick: PropTypes.func
  }),
  onSelect: PropTypes.func,
  highlightBorder: PropTypes.bool,
  disableCheckboxes: PropTypes.bool,
  disableMultiselect: PropTypes.bool,
  selectedCheckboxes: PropTypes.arrayOf(PropTypes.shape({}))
};

export default ImportTypeCheckboxComponent;
